import { useEffect } from "react";
import { X } from "lucide-react";

/**
 * Mobile-friendly bottom-sheet modal. Slides up from the bottom.
 *
 * Props:
 *   open: bool
 *   onClose: () => void
 *   title: string
 *   children: ReactNode (content)
 *   testId: optional data-testid for the sheet
 */
export default function BottomSheet({ open, onClose, title, children, testId = "bottom-sheet" }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center" data-testid={testId}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative w-full max-w-md bg-white rounded-t-3xl shadow-2xl animate-in slide-in-from-bottom duration-200"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1 rounded-full bg-stone-300" />
        </div>
        <div className="px-5 pb-2 pt-1 flex items-center justify-between">
          <h3 className="text-base font-semibold text-stone-800">{title}</h3>
          <button onClick={onClose} className="p-1 -mr-1 text-stone-400 hover:text-stone-600">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="px-5 pb-5">{children}</div>
      </div>
    </div>
  );
}
